import request from '@/utils/request'

// 查询公司简介列表
export function listCompany(query) {
  return request({
    url: '/ws/company/list',
    method: 'get',
    params: query
  })
}

